import React from "react";
import Image from "next/image";
import { cn } from "@/storyblok/utils/cn";

export default function ImageSimple({
  filename,
  alt,
  position = "imageCenter",
  size = "medium",
  backgroundColor = "bg-white",
}) {
  if (!filename) {
    return null;
  }

  const positionClasses = cn("object-cover", {
    "justify-center": position === "imageCenter",
    "justify-start": position === "imageLeft",
    "justify-end": position === "imageRight",
  });

  const sizeClasses = cn({
    "w-1/3": size === "small",
    "w-1/2": size === "medium",
    "w-full": size === "large",
  });

  const backgroundClasses = cn({
    "bg-bg-color-white": backgroundColor === "bg-white",
    "bg-bg-color-light": backgroundColor === "bg-light",
    "bg-bg-color-dark": backgroundColor === "bg-dark",
    "bg-bg-color-grey": backgroundColor === "bg-grey",
    "bg-bg-color-orange": backgroundColor === "bg-orange",
  });

  return (
    <div className={backgroundClasses}>
      <div className={`flex ${positionClasses} max-w-7xl py-16 mx-auto`}>
        <div className={`flex ${sizeClasses}`}>
          <Image
            src={`${filename}/m/1210x720`}
            layout="responsive"
            alt={alt || "Image"}
            width={1280}
            height={820}
            className="oobject-contain w-full h-auto"
          />
        </div>
      </div>
    </div>
  );
}
